<template>
  <!-- <transition name="anim-spinner"> -->
    <p 
      v-if="show"
      class="sm-spinner" 
      :class="{
        'global': isGlobal || popupOpen
      }"
    >
      <lottie
        :options="options"
        :height="100"
        :width="100"
        @animCreated="handleAnimation"
      />
      <!-- <span></span>
      <span></span>
      <span></span> -->
    </p>
  <!-- </transition> -->
</template>

<script>
import { mapGetters } from 'vuex';
import Lottie from 'vue-lottie';
import AnimationData from '@/assets/json/spinner.json';

export default {
  name: "sm-spinner",
  components: {
    'lottie': Lottie
  },
  props: {
    show: Boolean,
    isGlobal: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      options: {
        animationData: AnimationData
      }
    }
  },
  computed: {
    ...mapGetters({
      popupOpen: 'popupOpen'
    })
  },
  methods: {
    handleAnimation(data) {
    }
  }
};
</script>

<style lang="scss">
  .anim-spinner {
    &-enter { opacity: 0; }
    &-leave-to { opacity: 0; }
    // &-enter-active { transition: opacity .2s; }
    // &-leave-active { transition: opacity .2s; }
  }
</style>